import { z } from "zod";

export enum ReviewsLanguagesOptions {
  ALL = "all",
  JAPANESE_ONLY = "japanese_only",
  CUSTOM = "custom",
}

export const languagesSchema = z.object({
  option: z.nativeEnum(ReviewsLanguagesOptions),
  custom_values: z.array(z.string()), // for when option is CUSTOM
});

export type LanguagesSchema = z.infer<typeof languagesSchema>;

export const COMMON_LANGUAGES = [
  "ja",
  "en",
  "zh",
  "ko",
  "es",
  "fr",
  "de",
  "it",
  "th",
  "pt",
  "vi",
  "nl",
  "ru",
  "pl",
  "id",
  "he",
  "la",
  "da",
  "tr",
  "ca",
];
